import { apiClientV2 } from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_API_PUBLIC_EXTERNAL

export const getLogHistory = async (queryParam) => {
  const params = {
    page: queryParam?.page,
    limit: queryParam?.limit,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/integration-log',
    params: params,
  })

  return response?.data
}

export const retry = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/integration-log/retry',
    data: {
      id,
    },
  })

  return response?.data
}